










































































import { Component, Vue } from "vue-property-decorator";
import { required } from "vuelidate/lib/validators";
import { mapGetters, mapState } from "vuex";

@Component({
  data() {
    return {
      form: {
        login: "",
        password: ""
      }
    };
  },
  computed: {
    ...mapState(["userName", "apps", "tokens"]),
    ...mapGetters(["isAuth", "fullName", "dealer", "welcomeMsg"])
  },
  validations: {
    form: {
      login: {
        required
      },
      password: {
        required
      }
    }
  },
  methods: {
    signin() {
      this.$store.dispatch("signin", this.$data.form);
    },
    signout() {
      this.$data.form.login = "";
      this.$data.form.password = "";
      this.$v.$reset();
      this.$store.dispatch("signout", this.$data.form);
    }
  }
})
export default class Login extends Vue {}
